export default {
    init() {
       this.automaticBidToggle();
        this.bidPopUpInputChange();
        this.finalOfferBidToggle();
    },

    automaticBidToggle(){
        $('input[type=radio][name=winner-settings]').on('change', function() {
            $('.winner-settings-time-popup .automatic-bidding').addClass('disabled');
            $(this).parent().parent().parent().find('.automatic-bidding').removeClass('disabled');
        });
    },

    bidPopUpInputChange() {
        $('.pop-up-input-less').on('click', function (e) {
            e.preventDefault();
            let oldValue = $(this).parent().parent().find('input').val();
            let step = $(this).parent().parent().find('input').attr('step');
            let newVal = parseFloat(oldValue) - parseFloat(step);
            if(newVal>=0) {
                $(this).parent().parent().find('input').val(newVal);
            }
        });

        $('.pop-up-input-more').on('click', function (e) {
            e.preventDefault();
            let oldValue = $(this).parent().parent().find('input').val();
            let step = $(this).parent().parent().find('input').attr('step');
            let newVal = parseFloat(oldValue) + parseFloat(step);
            $(this).parent().parent().find('input').val(newVal);
        });
    },

    finalOfferBidToggle(){
        $('.final-offer-button').on('click',function(e){
            e.preventDefault();
            let parent = $(this).parent().parent();
            if($(parent).hasClass('final-offer-form')){
                $(parent).removeClass('final-offer-form');
                $('.final-offer-time--wrap').slideUp(300);
            } else{
                $(parent).addClass('final-offer-form');
                $('.final-offer-time--wrap').slideDown(300);
            }
        });

        $('.confirm-final-offer').on('click',function(e){
            e.preventDefault();
            $(this).parent().parent().addClass('final-offer-confirmed');
            $(this).html('cancel');
        });
    }


    //automatic-bid-switch

    // bidPopUpInputChange() {
    //     $('.bid-input-less').on('click', function (e) {
    //         e.preventDefault();
    //         let oldValue = $(this).parent().parent().find('input').val();
    //         let step = $(this).parent().parent().find('input').attr('step');
    //         let newVal = parseFloat(oldValue) - parseFloat(step);
    //         if(newVal>=0) {
    //             $(this).parent().parent().find('input').val(newVal);
    //         }
    //     });
    //
    //     $('.bid-input-more').on('click', function (e) {
    //         e.preventDefault();
    //         let oldValue = $(this).parent().parent().find('input').val();
    //         let step = $(this).parent().parent().find('input').attr('step');
    //         let newVal = parseFloat(oldValue) + parseFloat(step);
    //         $(this).parent().parent().find('input').val(newVal);
    //     });
    // },


}